module.exports = __webpack_public_path__ + "static/media/LA.ea526077.svg";